import React from 'react';
import PropTypes from 'prop-types';
// Utils
import iconSrc from '../../utils/iconSrc';
// Styles
import { VisuallyHidden } from '../styled/accessibility';
import {
  Banner,
  BannerToStick,
  ContentContainer,
  StyledContainer,
  TextContain,
  Title,
  SubTitle,
  Close,
  Icon,
  Link,
} from './styles';

const BannerContent = ({ title, subtitle, buttonTarget, buttonText }) => (
  <ContentContainer>
    <TextContain>
      {title ? <Title>{title}</Title> : null}
      {subtitle ? <SubTitle>{subtitle}</SubTitle> : null}
    </TextContain>
    <Link $bg="primary" href={buttonTarget}>
      {buttonText}
    </Link>
  </ContentContainer>
);

BannerContent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonTarget: PropTypes.string,
  buttonText: PropTypes.string,
};

/**
 * As banner needs to live as part of the normal DOM flow and also
 * be fixed at certain points, two banners rendered to avoid page jump
 */
const StickyBannerElement = ({
  stickyBarRef,
  bannerStuck,
  dismissFn,
  ...rest
}) => (
  <>
    <Banner ref={stickyBarRef}>
      <StyledContainer>
        <BannerContent {...rest} />
      </StyledContainer>
    </Banner>

    <BannerToStick
      $bannerStuck={bannerStuck}
      data-testid="sticky-banner-to-stick"
    >
      <StyledContainer>
        <BannerContent {...rest} />
        <Close type="button" onClick={() => dismissFn(true)}>
          <VisuallyHidden>Dismiss this banner</VisuallyHidden>
          <Icon src={iconSrc('cross')} aria-hidden="true" cacheRequests />
        </Close>
      </StyledContainer>
    </BannerToStick>
  </>
);

StickyBannerElement.propTypes = {
  bannerStuck: PropTypes.bool,
  stickyBarRef: PropTypes.object,
  dismissFn: PropTypes.func,
};

export default StickyBannerElement;
